import { Component, OnInit } from '@angular/core';
import { AbstractControl, AsyncValidatorFn, FormArray, FormBuilder, FormGroup, ValidationErrors, Validators } from '@angular/forms';
import { LearningCenterManagementService } from '../learning-center-management.service';
import { ActivatedRoute, Router } from '@angular/router';
import { BehaviorSubject, Observable, observable, of, timer } from 'rxjs';
import { values } from 'lodash';
import { es } from 'date-fns/locale';
import { LearningCenterContentComponent } from '../../learning-center/learning-center-content/learning-center-content.component';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { LearningCenterPreviewComponent } from './learning-center-preview/learning-center-preview.component';
import { catchError, filter, map, switchMap } from 'rxjs/operators';
import { ModalComponent } from 'src/app/shared/components/modal/modal.component';
import { GobalFunctionService } from 'src/app/core/services/gobal/gobal-function.service';

@Component({
  selector: 'app-manage-learning-center',
  templateUrl: './manage-learning-center.component.html',
  styleUrls: ['./manage-learning-center.component.scss'],
})
export class ManageLearningCenterComponent implements OnInit {
  learningCenterForm: FormGroup;
  isEdit: boolean = false;
  learningCenterColorTheme = new BehaviorSubject<any[]>([]);
  learningCenterColorTheme$ = this.learningCenterColorTheme.asObservable();
  CENTER_ID: string;
  previousCenterName: string;
  isLoading: boolean = false;

  constructor(private fb: FormBuilder, private gobalFunctionService: GobalFunctionService, private learningCenterManagementService: LearningCenterManagementService, private route: ActivatedRoute, public matDialog: MatDialog, private router: Router) { }

  ngOnInit(): void {
    try {
      this.route.queryParams.subscribe(params => {
        const CENTER_ID = params['CENTER_ID'];
        if (CENTER_ID) {
          
          this.CENTER_ID = CENTER_ID;
          this.isEdit = true;
          this.isLoading = true;
          this.learningCenterManagementService.getLearningCenter(CENTER_ID).subscribe((res) => {
            if (res.success && res.result.length > 0) {
              const data = res.result[0];
              this.previousCenterName = data.CENTER_NAME;
              this.gobalFunctionService.setTitle('แก้ไขศูนย์เรียนรู้ ' + this.previousCenterName);
              let CONTENT3 = this.fb.array([]);
              if (data.CONTENT3 && Array.isArray(data.CONTENT3) && data.CONTENT3.length > 0) {
                CONTENT3 = this.fb.array(data.CONTENT3.map(item => {
                  const formGroup = this.fb.group({
                    CONTENT3_TITLE: [item.CONTENT3_TITLE, Validators.required],
                    CONTENT3_DETAIL: [item.CONTENT3_DETAIL, Validators.required],
                    CONTENT3_IMAGE_PROFILE: [item.CONTENT3_IMAGE_PROFILE, Validators.required],
                    DATA_STATUS: ['original'], // set to 'original' when initialized from API
                    ID: [item.ID]
                  });

                  return formGroup;
                }));
              }

              let VIDEOS = this.fb.array([]);
              if (data.VIDEOS && Array.isArray(data.VIDEOS) && data.VIDEOS.length > 0) {
                VIDEOS = this.fb.array(data.VIDEOS.map(item => this.fb.group({
                  VIDEO_ID: [Number(item.VIDEO_ID)],
                  DATA_STATUS: ['original'],
                  ID: [item.ID],
                })));
              }

              let CONTENT3_IMAGE = this.fb.array([]);
              if (data.CONTENT3 && Array.isArray(data.CONTENT3) && data.CONTENT3.length > 0) {
                CONTENT3_IMAGE = this.fb.array(data.CONTENT3.map(item => this.fb.group({
                  IMAGE: [item.CONTENT3_IMAGE_URL],
                  IMAGE_DATA_STATUS: ['original']
                })));
              }

              // then use 'data' to set your form values
              this.learningCenterForm = this.fb.group({
                IMAGE_BANNER: [data.IMAGE_BANNER_URL, Validators.required],
                THEME_ID: [data.THEME_ID, Validators.required],
                CENTER_NAME: [data.CENTER_NAME, Validators.required, this.centerNameAsyncValidator(this.learningCenterManagementService)],
                CENTER_DESCRIPTION: [data.CENTER_DESCRIPTION, Validators.required],
                IMAGE_PROFILE: [data.IMAGE_PROFILE_URL, Validators.required],
                CONTENT2_DETAIL: [data.CONTENT2_DETAIL, Validators.required],
                VIEW_STATUS: [data.VIEW_STATUS],
                CONTENT3: CONTENT3,
                VIDEOS: VIDEOS,
                CONTENT3_IMAGE: CONTENT3_IMAGE,
                RESEARCH_TEXT: [data.RESEARCH_TEXT, Validators.required],
              });
            }
            this.isLoading = false;
          });
        } else {
          this.gobalFunctionService.setTitle('สร้างศูนย์เรียนรู้');
          this.learningCenterForm = this.fb.group({
            IMAGE_BANNER: ['', Validators.required],
            THEME_ID: [1, Validators.required],
            CENTER_NAME: ['', Validators.required,
              this.centerNameAsyncValidator(this.learningCenterManagementService)],
            CENTER_DESCRIPTION: ['', Validators.required],
            IMAGE_PROFILE: ['', Validators.required],
            CONTENT2_DETAIL: ['', Validators.required],
            VIEW_STATUS: [0],
            CONTENT3: this.fb.array([]),
            VIDEOS: this.fb.array([]),
            CONTENT3_IMAGE: this.fb.array([]),
            RESEARCH_TEXT: ['', Validators.required],
          });
        }
      });

    } catch (error) {
      console.log(error)
      this.isLoading = false;
    }

    this.isLoading = true;
    this.learningCenterManagementService.getLearningCenterTheme().subscribe((res) => {
      if (res.success) {
        this.learningCenterColorTheme.next(res.result);
        this.isLoading = false;
      }
    }, error => {
      console.log(error);
      this.isLoading = false;
      alert('เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง')
      window.location.reload();
    });
  }

  deleteLearningCenter() {
    this.isLoading = true;
    this.learningCenterManagementService.deleteLearningCenter({ CENTER_ID: this.CENTER_ID }).subscribe((res) => {
      if (res.success) {
        this.isLoading = false;
        const successText = 'ลบข้อมูลสำเร็จ'
        const dialogConfig = new MatDialogConfig();
        dialogConfig.disableClose = true;
        dialogConfig.id = 'modalConfirm';
        dialogConfig.width = '350px';
        dialogConfig.data = {
          title: 'สำเร็จ',
          description: '<img src="../../../assets/check.png" width="100px;" class="img-center">' + '<br>' + successText,
          cancleBtnText: 'ยืนยัน',
          customStyle: 'background-color: #58595B;'
        }

        const modal = this.matDialog.open(ModalComponent, dialogConfig);
        modal.afterClosed().subscribe(res => {
            this.router.navigate(['/learning-center-management']);
        })
      }
    });
  }

  centerNameAsyncValidator(
    learningCenterManagementService: LearningCenterManagementService
  ): AsyncValidatorFn {
    return (control: AbstractControl): Observable<ValidationErrors | null> => {
      return timer(800).pipe(
        filter(_ => !!control.value),
        switchMap(() => {
          if (this.isEdit && control.value === this.previousCenterName) {
            // If the value hasn't changed, we consider it valid
            return of(null);
          } else {
            return learningCenterManagementService
              .checkCenterNameAvailability({ CENTER_NAME: control.value })
              .pipe(
                map(response => response.success ? null : { invalidName: true }),
                catchError(() => of({ invalidName: true }))
              );
          }
        })
      );
    };
  }


  get content3() {
    return this.learningCenterForm.get('CONTENT3') as FormArray;
  }

  get videos() {
    return this.learningCenterForm.get('VIDEOS') as FormArray;
  }

  transformToFormData(formValue: any): FormData {
    const formData = new FormData();

    // The base fields.
    const baseFields = ['CENTER_NAME', 'THEME_ID', 'CENTER_DESCRIPTION', 'CONTENT2_DETAIL', 'RESEARCH_TEXT'];

    let filteredContent3 = formValue.CONTENT3.filter(content => content.DATA_STATUS !== 'remove');
    let filteredVideos = formValue.VIDEOS.filter(video => video.DATA_STATUS !== 'remove');
    let filteredContent3Image = formValue.CONTENT3_IMAGE.filter(content => content.IMAGE_DATA_STATUS !== 'remove');

    for (const field of baseFields) {
      if (formValue[field]) {
        formData.append(field, formValue[field]);
      }
    }

    // Handle IMAGES_BANNER and IMAGE_PROFILE if they are File objects.
    if (formValue['IMAGE_BANNER'] && formValue['IMAGE_BANNER'] instanceof File) {
      formData.append('IMAGE_BANNER', formValue['IMAGE_BANNER']);
    }

    if (formValue['IMAGE_PROFILE'] && formValue['IMAGE_PROFILE'] instanceof File) {
      formData.append('IMAGE_PROFILE', formValue['IMAGE_PROFILE']);
    }

    // Handle CONTENT3 array.
    filteredContent3.forEach((content3, index) => {
      for (const key in content3) {
        if (key !== 'DATA_STATUS') {
          formData.append(`CONTENT3[${index}][${key}]`, content3[key]);
        }
      }
    });

    // Handle VIDEOS array.
    filteredVideos.forEach((video, index) => {
      formData.append(`VIDEOS[${index}][VIDEO_ID]`, video['VIDEO_ID']);
    });

    // Handle CONTENT3_IMAGE array.
    filteredContent3Image.forEach((image, index) => {
      if (image['IMAGE'] && image['IMAGE'] instanceof File) {
        formData.append('CONTENT3_IMAGE', image['IMAGE']);
      }
    });

    return formData;
  }

  tranformToFormDataForUpdate(formValue: any): FormData {
    const formData = new FormData();

    // Base fields.
    const baseFields = ['CENTER_NAME', 'THEME_ID', 'CENTER_DESCRIPTION', 'CONTENT2_DETAIL', 'RESEARCH_TEXT'];

    formData.append('CENTER_ID', this.CENTER_ID);

    for (const field of baseFields) {
      if (formValue[field]) {
        formData.append(field, formValue[field]);
      }
    }

    // Handle IMAGE_BANNER and IMAGE_PROFILE if they are File objects.
    if (formValue['IMAGE_BANNER'] && formValue['IMAGE_BANNER'] instanceof File) {
      formData.append('IMAGE_BANNER', formValue['IMAGE_BANNER']);
    }

    if (formValue['IMAGE_PROFILE'] && formValue['IMAGE_PROFILE'] instanceof File) {
      formData.append('IMAGE_PROFILE', formValue['IMAGE_PROFILE']);
    }

    // Handle CONTENT3 array.

    if (formValue['CONTENT3'] && Array.isArray(formValue['CONTENT3'])) {

      formValue['CONTENT3'].forEach((content3, index) => {

        if (content3['CONTENT3_TITLE']) {
          formData.append(`CONTENT3[${index}][CONTENT3_TITLE]`, content3['CONTENT3_TITLE']);
        }
        if (content3['CONTENT3_DETAIL']) {
          formData.append(`CONTENT3[${index}][CONTENT3_DETAIL]`, content3['CONTENT3_DETAIL']);
        }
        if (content3['CONTENT3_IMAGE_PROFILE'] && content3['CONTENT3_IMAGE_PROFILE']) {
          formData.append(`CONTENT3[${index}][CONTENT3_IMAGE_PROFILE]`, content3['CONTENT3_IMAGE_PROFILE']);
        }
        if (content3['DATA_STATUS']) {
          formData.append(`CONTENT3[${index}][DATA_STATUS]`, content3['DATA_STATUS']);
        }
        if (content3['ID'] && content3['DATA_STATUS'] !== 'add') {
          formData.append(`CONTENT3[${index}][ID]`, content3['ID']);
        }
      });
    }

    // Handle VIDEOS array.
    if (formValue['VIDEOS'] && Array.isArray(formValue['VIDEOS'])) {
      formValue['VIDEOS'].forEach((video, index) => {
        if (video['VIDEO_ID']) {
          formData.append(`VIDEOS[${index}][VIDEO_ID]`, video['VIDEO_ID']);
        }
        if (video['DATA_STATUS']) {
          formData.append(`VIDEOS[${index}][DATA_STATUS]`, video['DATA_STATUS']);
        }
        if (video['ID']) {
          formData.append(`VIDEOS[${index}][ID]`, video['ID']);
        }
      });
    }

    // Handle CONTENT3_IMAGE array.
    if (formValue['CONTENT3_IMAGE'] && Array.isArray(formValue['CONTENT3_IMAGE'])) {
      formValue['CONTENT3_IMAGE'].forEach((image, index) => {
        if (image['IMAGE'] && image['IMAGE'] instanceof File) {
          formData.append(`CONTENT3_IMAGE`, image['IMAGE']);
        }
      });
    }

    return formData;
  }

  onSubmit() {
    if (this.validateForm()) {
      this.isEdit ? this.updateLearningCenter() : this.createLearningCenter();
    }
  }

  validateForm() {
    // this.removeValidationForRemovedContent3();
    if (this.learningCenterForm.invalid) {
      this.markControlsAsDirtyAndValidate(this.learningCenterForm);
      return false;
    } else {
      return true;
    }
  }

  removeValidationForRemovedContent3() {
    const content3Array = this.content3;

    content3Array.controls.forEach(control => {
      if (control.get('DATA_STATUS').value === 'remove') {
        control.disable();
      }
    });
  }

  markControlsAsDirtyAndValidate(group: FormGroup | FormArray) {
    Object.values(group.controls).forEach(control => {
      if (control instanceof FormGroup || control instanceof FormArray) {
        this.markControlsAsDirtyAndValidate(control);
      } else if (control.invalid) {

        control.markAsDirty();
        control.updateValueAndValidity({ onlySelf: true });
      }
    });
  }

  updateLearningCenter() {
    const formData = this.tranformToFormDataForUpdate(this.learningCenterForm.value);
  }

  createLearningCenter() {
    const formData = this.transformToFormData(this.learningCenterForm.value);
  }

  toBase64(file: File): Promise<string> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result as string);
      reader.onerror = error => reject(error);
    });
  }

  async transformFormValue(learningCenterForm: FormGroup): Promise<any> {
    const formValue = learningCenterForm.value;
    const imageBannerBase64 = formValue.IMAGE_BANNER instanceof File ? await this.base64Promise(formValue.IMAGE_BANNER) : formValue.IMAGE_BANNER;
    const imageProfileBase64 = formValue.IMAGE_PROFILE instanceof File ? await this.base64Promise(formValue.IMAGE_PROFILE) : formValue.IMAGE_PROFILE;
    let filteredContent3 = formValue.CONTENT3.filter(content => content.DATA_STATUS !== 'remove');
    let filteredContent3Image = formValue.CONTENT3_IMAGE.filter(content => content.IMAGE_DATA_STATUS !== 'remove');
    const content3ImagePromises = filteredContent3Image.map((imageObject) =>
      imageObject.IMAGE instanceof File ? this.base64Promise(imageObject.IMAGE) : Promise.resolve(imageObject.IMAGE)
    );
    const content3ImagesBase64 = await Promise.all(content3ImagePromises);
    let filteredVideos = formValue.VIDEOS.filter(video => video.DATA_STATUS !== 'remove');

    return {
      CENTER_ID: this.CENTER_ID ? this.CENTER_ID : 'Preview',
      CENTER_NAME: formValue.CENTER_NAME,
      IMAGE_BANNER_URL: imageBannerBase64,
      THEME_ID: formValue.THEME_ID,
      CENTER_DESCRIPTION: formValue.CENTER_DESCRIPTION,
      IMAGE_PROFILE_URL: imageProfileBase64,
      CONTENT2_DETAIL: formValue.CONTENT2_DETAIL,
      VIEW_STATUS: formValue.VIEW_STATUS,
      CONTENT3: filteredContent3.map((content, index) => ({
        ...content,
        CONTENT3_IMAGE_URL: content3ImagesBase64[index]
      })),
      VIDEOS: filteredVideos.map((video) => ({
        VIDEO_ID: video.VIDEO_ID
      })),
      RESEARCH_TEXT: formValue.RESEARCH_TEXT,
      // Other fields...
    };
  }

  private base64Promise(fileOrUrl: File | string): Promise<string> {
    if (typeof fileOrUrl === 'string') {
      return Promise.resolve(fileOrUrl);
    } else {
      return this.toBase64(fileOrUrl);  // return the promise
    }
  }

  async openModal() {
    if (this.validateForm()) {
      const data = await this.transformFormValue(this.learningCenterForm)
      const formData = this.isEdit ? this.tranformToFormDataForUpdate(this.learningCenterForm.value) : this.transformToFormData(this.learningCenterForm.value);
      let theme
      this.learningCenterColorTheme$.pipe(
        switchMap((res) => {
          // find value form learningCenterForm theme id
          theme = res.find((theme) => theme.THEME_ID === this.learningCenterForm.value.THEME_ID);
          return of(theme);
        })
      ).subscribe(() => {
        const dialogConfig = new MatDialogConfig();
        dialogConfig.id = this.CENTER_ID ? this.CENTER_ID : 'Preview';
        dialogConfig.height = 'auto';
        dialogConfig.width = '80%'
        dialogConfig.autoFocus = false
        dialogConfig.data = {
          centerDetail: data,
          theme: theme,
          title: data.CENTER_NAME,
          cancelBtnText: 'ย้อนกลับเพื่อแก้ไข',
          formData: formData,
          isEdit: this.isEdit
        }
        const formDialog = this.matDialog.open(LearningCenterPreviewComponent, dialogConfig);
      });
    }
  }
}
